export const YOUTUBE_BASE_LONG_URL = 'youtube.com';
export const YOUTUBE_BASE_SHORT_URL = 'youtu.be';
